import axios from "axios"
import {Message} from "element-ui"
import router from "../router/index"
import Cookie from "js-cookie";


const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    // baseURL: process.env.VUE_APP_BASE_API,
    // 超时
    // timeout: 10*60000
    // timeout: 3000
})

// request拦截器
service.interceptors.request.use(config => {
    // 是否需要设置 token

    if (localStorage.getItem('token')) {
        config.headers.Authorization = localStorage.getItem('token')
    }

    return config
}, error => {
    console.error(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
        // 未设置状态码则默认成功状态
        // console.log(res)
        //  登录过期
        if (res.data.code === '401') {
            // console.log('登录过期')
            Message.success(res.data.message)
            Cookie.remove("BSG-userInfo");
            localStorage.removeItem('token')
            localStorage.removeItem('userName')
            localStorage.removeItem('userType')
            setTimeout(() => {
                router.replace({
                    name: 'login'
                })
            }, 500)
            return null
        } else {
            return res
        }

    },
    error => {
        console.log('err' + error)
        Message.error('系统错误,请联系管理员')
        return error
        // return Promise.reject(error)
    }
)

export default service
